((app) => {

    app.constant("_insuranceAccountStatuses",
        [
            {
                name: "ApplicationSigned",
                toString() {
                    return "Application Signed";
                }
            },
            {
                name: "SubmittedToFIG",
                toString() {
                    return "Submitted to FIG";
                }
            },
            {
                name: "SubmittedToCarrier",
                toString() {
                    return "Submitted to Carrier";
                }
            },
            {
                name: "Pending",
                toString() {
                    return "Pending";
                }
            },
            {
                name: "Approved",
                toString() {
                    return "Approved";
                }
            },
            {
                name: "Issued",
                toString() {
                    return "Issued";
                }
            },
            {
                name: "Inforce",
                toString() {
                    return "Inforce";
                }
            },
        ]);

})(window.app);